module.exports = __webpack_public_path__ + "static/media/logo-negative.066419d4.png";